import { FC } from 'react';
import { Upload, UploadFile, UploadProps } from 'antd';
import { TbPaperclip } from 'react-icons/tb';

import { EmptyView } from '@/shared/components/layouts/views/EmptySection';

export const ACCEPTED_ATTACHMENT_EXTENSIONS = '.zip,.json,.txt,.pdf,.doc,.docx,.png,.jpg,.jpeg,.xlsx,.xls,.csv';
export const MAX_ATTACHMENT_BATCH_FILES = 100;

interface StagedAttachmentDropzoneProps {
    disabled?: boolean;
    files: UploadFile[];
    onChange: (files: UploadFile[]) => void;
}

const StagedAttachmentDropzone: FC<StagedAttachmentDropzoneProps> = ({ disabled, files, onChange }): JSX.Element => {
    const uploadProps: UploadProps = {
        accept: ACCEPTED_ATTACHMENT_EXTENSIONS,
        beforeUpload: () => false,
        disabled,
        fileList: files,
        maxCount: MAX_ATTACHMENT_BATCH_FILES,
        multiple: true,
        onChange: ({ fileList }) => onChange(fileList.slice(0, MAX_ATTACHMENT_BATCH_FILES)),
        onRemove: (file) => {
            onChange(files.filter((candidate) => candidate.uid !== file.uid));
            return true;
        },
    };

    return (
        <Upload.Dragger {...uploadProps} style={{ padding: files.length ? '0.5rem' : '0.75rem' }}>
            <EmptyView
                description='Drag and drop files, or click anywhere in this area to browse.'
                height='7.5rem'
                icon={<TbPaperclip size='1.25rem' />}
                label={files.length ? 'Add More Attachments' : 'Add Attachments'}
            />
        </Upload.Dragger>
    );
};

export default StagedAttachmentDropzone;
